import React from 'react';
import classes from './styles.module.scss';
import Layout from '../../components/Layout';
import { ReactComponent as PageNotFoundSVG } from '../../assets/404.svg';
import ErrorImg from '../../assets/404.png';
import SKButton from '../../components/UI/SKButton';
import { useNavigate } from 'react-router-dom';
import { HOME_PAGE } from '../../constants/route.const';
import { Box, Heading, Image } from '@chakra-ui/react';

export default function Error404() {
  const navigate = useNavigate();
  return (
    <Layout>
      <Box className={classes.PageNotFound} mt={8}>
        <Image
          src={ErrorImg}
          alt="Page not found"
          width={['200px', null, null, '400px']}
        />
        <Heading mt={18}>Page Not Found</Heading>
        <Heading as="h3" fontSize={'20px'} fontWeight={400}>
          The Page you are looking for cannot be found.
        </Heading>
        <SKButton onClick={() => navigate(HOME_PAGE)} color="white">
          Back to Homepage
        </SKButton>
      </Box>
    </Layout>
  );
}
